export default [

     {
          path: '/data-product',
          name: 'DataProduct',
          component: () => import("@/views/Page/DataProduct/DataProduct.vue"),
           meta: {
               title: '#Default# | DataProduct',
          },
     }
];